import { Dispatch, SetStateAction, useEffect } from 'react';
import { Desktop, Mobile } from '../../../App';
import { BACKOFFICE_NAME, USDT } from '../../../helpers/helperFunctions';
import { CaptionText, H2, H3, P1 } from '../../../styles/FontStyles';
import { Flexed } from '../../../styles/GlobalComponents';
import { color } from '../../../styles/GlobalStyles';

import { Checkbox } from '../Checkbox/Checkbox';

import { useTranslation } from 'react-i18next';
import { VirtualOfficeSubscriptionStyled } from './VirtualOfficeSubscription.styled';
import { useAppSelector } from '../../../app/hooks';

interface VirtualOfficePlanProps {
  selected: any;
  setSelected: Dispatch<SetStateAction<any>>;
  checkedLicence: boolean;
  setCheckedLicence: Dispatch<SetStateAction<boolean>>;
}

export const VirtualOfficePlan = ({
  checkedLicence,
  setSelected,
  setCheckedLicence
}: VirtualOfficePlanProps) => {
  const { licences } = useAppSelector((state) => state.settings);

  return (
    <div>
      <P1 bold mb='20' mt='10' caps>
        Add {BACKOFFICE_NAME} SUBSCRIPTION:
      </P1>
      {licences?.map((plan, i) => (
        <VirtualOfficeSubscriptionStyled
          key={i}
          onClick={() => {
            setSelected(plan);
            setCheckedLicence(!checkedLicence);
          }}>
          <div>
            <Flexed between>
              <Flexed center>
                <Checkbox
                  margin='0 20px 0 0'
                  size='38'
                  onClick={() => {
                    setSelected(plan);
                    setCheckedLicence(!checkedLicence);
                  }}
                  checked={checkedLicence}
                />
                <div>
                  <H3>{plan.name}</H3>
                </div>
              </Flexed>
              <Flexed alignEnd column>
                <Desktop>
                  <H2>
                    ${plan.price} {USDT}
                  </H2>
                </Desktop>
                <Mobile>
                  <H3>
                    ${plan.price} {USDT}
                  </H3>
                </Mobile>
              </Flexed>
            </Flexed>
          </div>
        </VirtualOfficeSubscriptionStyled>
      ))}
    </div>
  );
};
